// extracted by mini-css-extract-plugin
export default {"header":"MobileHeader_header__5fdN8","title":"MobileHeader_title__Ac3kj","backBtn":"MobileHeader_backBtn__4gBBP","spacer":"MobileHeader_spacer__CaZQv"};